import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { IUpdateCartRequestV2 } from "@faire/web-api--source/faire/carts/IUpdateCartRequestV2";
export var IBrandCartV2WithSummary;
(function(IBrandCartV2WithSummary) {
    IBrandCartV2WithSummary.build = function(partial) {
        return _object_spread({
            checkout_summary: undefined
        }, IBrandCartV2.build(partial));
    };
})(IBrandCartV2WithSummary || (IBrandCartV2WithSummary = {}));
export var ILeanBrandCheckoutSummary;
(function(ILeanBrandCheckoutSummary) {
    ILeanBrandCheckoutSummary.build = function(partial) {
        return _object_spread({
            order_summary_line_items: [],
            disclaimer: undefined
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ILeanBrandCheckoutSummary || (ILeanBrandCheckoutSummary = {}));
export var ILeanCartItem;
(function(ILeanCartItem) {
    ILeanCartItem.build = function(partial) {
        return _object_spread({
            product_token: undefined,
            product_option_token: undefined,
            customizations: [],
            includes_tester: undefined,
            quantity: undefined
        }, partial !== null && partial !== void 0 ? partial : {});
    };
})(ILeanCartItem || (ILeanCartItem = {}));
export var ICartItemForUpdate;
(function(ICartItemForUpdate) {
    ICartItemForUpdate.build = IUpdateCartRequestV2.ICartItemForUpdate.build;
})(ICartItemForUpdate || (ICartItemForUpdate = {}));
export var CartsTabs;
(function(CartsTabs) {
    CartsTabs["ALL_BRAND"] = "ALL_BRAND";
    CartsTabs["SAVED_FOR_LATER"] = "SAVED_FOR_LATER";
})(CartsTabs || (CartsTabs = {}));
